import { AppRouteGroup } from 'routing/classes/AppRouteGroup';

export const routeGroup = new AppRouteGroup('');

export const localizedRouteGroup = new AppRouteGroup('/:lang');

export const homeRoute = localizedRouteGroup.rootRoute();

export const userInviteRoute = routeGroup.route('user-invites/:inviteId');

export const signupRoute = routeGroup.route('signup', ['invite']);

// Post a listing

export const postAListingRoute = routeGroup.route('post-a-listing', [
  'listingType',
]);

export const createJobRoute = routeGroup.route('jobs/create');

export const createInternshipRoute = routeGroup.route('internships/create');

// Invoice

export const viewInvoiceRoute = routeGroup.route('invoices/:invoiceId');

export const viewDonationReceiptRoute = routeGroup.route(
  'donation-receipts/:invoiceId',
);
